/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UiNodeScriptAttributes { 
    /**
     * The script async type
     */
    async: boolean;
    /**
     * The script cross origin policy
     */
    crossorigin: string;
    /**
     * A unique identifier
     */
    id: string;
    /**
     * The script\'s integrity hash
     */
    integrity: string;
    /**
     * NodeType represents this node\'s types. It is a mirror of `node.type` and is primarily used to allow compatibility with OpenAPI 3.0. In this struct it technically always is \"script\". text Text input Input img Image a Anchor script Script
     */
    node_type: UiNodeScriptAttributes.NodeTypeEnum;
    /**
     * Nonce for CSP  A nonce you may want to use to improve your Content Security Policy. You do not have to use this value but if you want to improve your CSP policies you may use it. You can also choose to use your own nonce value!
     */
    nonce: string;
    /**
     * The script referrer policy
     */
    referrerpolicy: string;
    /**
     * The script source
     */
    src: string;
    /**
     * The script MIME type
     */
    type: string;
}
export namespace UiNodeScriptAttributes {
    export type NodeTypeEnum = 'text' | 'input' | 'img' | 'a' | 'script';
    export const NodeTypeEnum = {
        Text: 'text' as NodeTypeEnum,
        Input: 'input' as NodeTypeEnum,
        Img: 'img' as NodeTypeEnum,
        A: 'a' as NodeTypeEnum,
        Script: 'script' as NodeTypeEnum
    };
}


